import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { utils } from "@alife/cone-arms-core";
import { observeEventDelay } from "./observe-event-delay";
import { init as initObservePageScroll, getData as getScrollPageData, reset as resetScrollPageTimes } from "./observe-page-scroll";
import { init as initDomTreeObserver } from "./observe-domtree-change";
import { initLongTaskObserver } from "./observe-long-task";
import { initResourceObserver } from "./observe-resource-load";
import { init as initPageClick, getData as getPageClickData, reset as resetPageClickList } from "./observe-page-click";
import { init as initObserveActiveStay, getData as getActiveStayData, reset as resetActiveStay } from "./observe-active-stay";
import { isInDingTalkWebView } from "./utils";
var checkWin = utils.checkWin, getCommonInfo = utils.getCommonInfo, hookHashChange = utils.hookHashChange, hookHistory = utils.hookHistory, bindEvent = utils.bindEvent;
var TraceWebRuntimePlugin = function(core) {
    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!(core && checkWin())) {
        return;
    }
    var commonInfo = {};
    var timerId;
    var hadTriggerUnload = false;
    var domTreeObserver = initDomTreeObserver();
    var eventDelayObserver = observeEventDelay();
    var longTaskObserver = initLongTaskObserver();
    var resourceObserver = initResourceObserver();
    var stopObserveActiveStay = initObserveActiveStay();
    var init = function() {
        var _eventDelayObserver, _longTaskObserver, _resourceObserver;
        commonInfo = getCommonInfo(core.config.ignoredQueries || [], core.config);
        (_eventDelayObserver = eventDelayObserver) === null || _eventDelayObserver === void 0 ? void 0 : _eventDelayObserver.reset();
        resetScrollPageTimes();
        domTreeObserver.reset();
        (_longTaskObserver = longTaskObserver) === null || _longTaskObserver === void 0 ? void 0 : _longTaskObserver.reset();
        (_resourceObserver = resourceObserver) === null || _resourceObserver === void 0 ? void 0 : _resourceObserver.reset();
        resetActiveStay();
        resetPageClickList();
    };
    var log = function() {
        var _eventDelayObserver, _longTaskObserver, _eventDelayObserver1, _longTaskObserver1, _resourceObserver;
        var eventResponseDelayList = ((_eventDelayObserver = eventDelayObserver) === null || _eventDelayObserver === void 0 ? void 0 : _eventDelayObserver.getLongEventList()) || [];
        var longTaskList = ((_longTaskObserver = longTaskObserver) === null || _longTaskObserver === void 0 ? void 0 : _longTaskObserver.getData()) || [];
        core.logRunTime(_object_spread(_object_spread_props(_object_spread({}, commonInfo), {
            stayTime: getActiveStayData(),
            eventResponseDelayList: eventResponseDelayList,
            eventResponseDelayTimes: ((_eventDelayObserver1 = eventDelayObserver) === null || _eventDelayObserver1 === void 0 ? void 0 : _eventDelayObserver1.getLongEventListLength()) || 0,
            longTaskList: longTaskList,
            longTaskTimes: ((_longTaskObserver1 = longTaskObserver) === null || _longTaskObserver1 === void 0 ? void 0 : _longTaskObserver1.getLongTaskCount()) || 0
        }), domTreeObserver.getData(), ((_resourceObserver = resourceObserver) === null || _resourceObserver === void 0 ? void 0 : _resourceObserver.getData()) || {}, getScrollPageData(), getPageClickData()));
    };
    init();
    var handleBeforeunload = function() {
        if (hadTriggerUnload) {
            return;
        }
        log();
        hadTriggerUnload = true;
    };
    var handleSpaPageChange = function() {
        clearTimeout(timerId);
        timerId = setTimeout(function() {
            var _getCommonInfo, _commonInfo;
            var url = (_getCommonInfo = getCommonInfo(core.config.ignoredQueries || [], core.config)) === null || _getCommonInfo === void 0 ? void 0 : _getCommonInfo.url;
            if (url !== ((_commonInfo = commonInfo) === null || _commonInfo === void 0 ? void 0 : _commonInfo.url)) {
                log();
                init();
            }
        }, 50);
    };
    var unbindBeforeunload = bindEvent(window, "beforeunload", handleBeforeunload);
    // 兼容移动端不触发beforeunload的情况
    var terminationEvent = "onpagehide" in window ? "pagehide" : "unload";
    var unbindUnload = bindEvent(window, terminationEvent, handleBeforeunload);
    var routeType = config.routeType || core.config.spaRouteType;
    var unbindHashChange = routeType !== "history" ? hookHashChange(handleSpaPageChange) : function() {};
    var unbindHistoryChange = routeType !== "hash" ? hookHistory(handleSpaPageChange) : function() {};
    var unbindPageScrollEvent = initObservePageScroll();
    var unbindClickEvent = initPageClick();
    // let unbindPauseEvent = () => {};
    var unbindBackButtonClickEvent = function() {};
    if (isInDingTalkWebView()) {
        // pause事件会在切到后台和打开新窗口链接后触发，不能替代beforeunload
        // unbindPauseEvent = bindEvent(document, 'pause', handleBeforeunload);
        unbindBackButtonClickEvent = bindEvent(document, "backbutton", handleBeforeunload);
    }
    return function() {
        var _eventDelayObserver, _longTaskObserver, _resourceObserver;
        unbindHashChange && unbindHashChange();
        unbindHistoryChange();
        unbindBeforeunload && unbindBeforeunload();
        unbindPageScrollEvent();
        unbindClickEvent();
        domTreeObserver.unbind();
        (_eventDelayObserver = eventDelayObserver) === null || _eventDelayObserver === void 0 ? void 0 : _eventDelayObserver.unbind();
        (_longTaskObserver = longTaskObserver) === null || _longTaskObserver === void 0 ? void 0 : _longTaskObserver.unbind();
        (_resourceObserver = resourceObserver) === null || _resourceObserver === void 0 ? void 0 : _resourceObserver.unbind();
        stopObserveActiveStay();
        unbindUnload();
        // unbindPauseEvent();
        unbindBackButtonClickEvent();
    };
};
export default TraceWebRuntimePlugin;

 //# sourceMappingURL=index.js.map